/* DIVETTA MILANO — surgical runtime owner, 02SEP2026 r2.
   Keeps Collection background-video user control.
   Removes the legacy Home phrase-pause owner completely.
   Adds presentation-only guards for route overflow, Home mobile stable layout,
   canonical trust labels and PDP mobile sticky timing. No cart/product data ownership. */
(() => {
  'use strict';
  const OWNER = 'ld-r7-surgical-close-02sep2026-r2';
  if (window.__ldR7SurgicalClose31Aug === OWNER) return;
  window.__ldR7SurgicalClose31Aug = OWNER;

  const HERO = 'ldx-sakazuki-single-video-hero';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new WeakMap();
  let pdpGuard = null;

  const installReleaseStyle = () => {
    if (document.getElementById('LDR7ReleaseFix02Sep')) return;
    const style = document.createElement('style');
    style.id = 'LDR7ReleaseFix02Sep';
    style.textContent = `
      body:is([data-r7-route='collection'],[data-r7-route='product']) #MainContent{
        min-inline-size:0;max-inline-size:100%;overflow-x:clip
      }
      body[data-r7-route='collection'] :is(.ldx-sakazuki-single-video-hero,.ldx-sakazuki-scene,.ldx-sakazuki-scene__content,.ldx-capelli-chapter__card),
      body[data-r7-route='product'] :is(.ld-commerce-pdp,.ld-commerce-buybox,.ld-commerce-mobile-bar),
      .r7-footer{
        min-inline-size:0;max-inline-size:100%;box-sizing:border-box
      }
      body[data-r7-route='collection'] :is(.ldx-sakazuki-scene__title,.ldx-capelli-chapter__title){
        max-inline-size:100%;white-space:normal!important;word-break:normal!important;overflow-wrap:normal!important;
        hyphens:none!important;font-variant-ligatures:none;font-feature-settings:'kern' 1,'liga' 0,'clig' 0;
        word-spacing:.11em!important
      }
      .r7-footer .ld-home-film__cert-trigger{min-inline-size:0!important;max-inline-size:100%!important;box-sizing:border-box!important}
      .r7-footer .ld-home-film__cert-trigger .ld-home-film__sr-only{
        position:static!important;inset:auto!important;display:grid!important;grid-template-columns:minmax(0,1fr)!important;
        gap:.35rem!important;width:auto!important;height:auto!important;min-width:0!important;max-width:100%!important;
        margin:0!important;padding:0!important;overflow:visible!important;clip:auto!important;clip-path:none!important;
        white-space:normal!important
      }
      .r7-footer .ld-home-film__cert-trigger :is(.ld-home-film__cert-public,.ld-home-film__cert-type){
        position:static!important;display:block!important;min-width:0!important;max-width:100%!important;margin:0!important;
        white-space:normal!important;word-break:normal!important;overflow-wrap:break-word!important;line-height:1.28!important
      }
      @media(max-width:989px){
        body[data-r7-route='product'] .ld-commerce-mobile-bar{
          opacity:0!important;visibility:hidden!important;pointer-events:none!important;
          transform:translate3d(0,calc(100% + env(safe-area-inset-bottom)),0)!important
        }
        body[data-r7-route='product'] .ld-commerce-mobile-bar.is-visible[data-ld-release-visible='true']{
          opacity:1!important;visibility:visible!important;pointer-events:auto!important;transform:translate3d(0,0,0)!important
        }
        body[data-r7-route='product'] .ld-commerce-mobile-bar__variant:empty{display:none!important}
      }
    `;
    document.head.appendChild(style);
  };

  class CollectionVideoControl {
    constructor(root) {
      this.root = root;
      this.video = root.querySelector('[data-ldx-single-video]');
      this.button = null;
      this.userPaused = false;
      this.abort = new AbortController();
      this.observer = null;
    }
    connect() {
      if (!(this.video instanceof HTMLVideoElement)) return false;
      const existing = this.root.querySelector('[data-ldx-user-video-toggle]');
      existing?.remove?.();
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ldx-sakazuki-single-video-hero__user-video-toggle';
      button.dataset.ldxUserVideoToggle = '';
      button.hidden = true;
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', 'Pausa video di sfondo');
      button.textContent = 'PAUSA VIDEO';
      this.button = button;
      this.root.append(button);
      button.addEventListener('click', () => this.toggle(), { signal: this.abort.signal });
      this.video.addEventListener('play', () => {
        if (!this.userPaused) return;
        requestAnimationFrame(() => { if (this.userPaused && !this.video.paused) this.video.pause(); });
      }, { signal: this.abort.signal });
      reduced.addEventListener?.('change', () => this.sync(), { signal: this.abort.signal });
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.root, { attributes: true, attributeFilter: ['data-opening-state', 'data-environment-fading'] });
      this.observer.observe(this.video, { attributes: true, attributeFilter: ['data-playback-disabled'] });
      this.sync();
      return true;
    }
    available() {
      return Boolean(this.video && !reduced.matches && this.video.dataset.playbackDisabled !== 'true' &&
        this.root.dataset.openingState === 'COLLECTION_READY' && this.root.dataset.environmentFading !== 'true');
    }
    sync() {
      if (!this.button) return;
      const available = this.available();
      this.button.hidden = !available;
      this.button.disabled = !available;
      this.button.setAttribute('aria-pressed', String(this.userPaused));
      this.button.setAttribute('aria-label', this.userPaused ? 'Riprendi video di sfondo' : 'Pausa video di sfondo');
      this.button.textContent = this.userPaused ? 'RIPRENDI VIDEO' : 'PAUSA VIDEO';
      if (!available && !this.video.paused && (reduced.matches || this.root.dataset.environmentFading === 'true')) this.video.pause();
    }
    toggle() {
      if (!this.available()) return;
      this.userPaused = !this.userPaused;
      if (this.userPaused) { this.video.pause(); this.sync(); return; }
      this.sync();
      const play = this.video.play();
      play?.catch?.(() => {
        this.userPaused = true;
        this.root.dataset.userVideoWarning = 'play-rejected';
        this.sync();
      });
    }
    destroy() {
      this.abort.abort();
      this.observer?.disconnect();
      this.button?.remove();
      instances.delete(this.root);
    }
  }

  class PdpPresentationGuard {
    constructor() {
      this.buybox = document.querySelector("body[data-r7-route='product'] .ld-commerce-buybox");
      this.bar = document.querySelector("body[data-r7-route='product'] .ld-commerce-mobile-bar");
      this.variant = this.bar?.querySelector('.ld-commerce-mobile-bar__variant') || null;
      this.abort = new AbortController();
      this.observer = null;
      this.frame = 0;
    }
    connect() {
      if (!(this.buybox instanceof Element) || !(this.bar instanceof Element)) return false;
      const requestSync = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
      };
      window.addEventListener('scroll', requestSync, { passive: true, signal: this.abort.signal });
      window.addEventListener('resize', requestSync, { passive: true, signal: this.abort.signal });
      this.observer = new MutationObserver(requestSync);
      this.observer.observe(this.bar, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true, characterData: true });
      this.sync();
      return true;
    }
    cleanVariant() {
      if (!(this.variant instanceof Element)) return;
      const value = (this.variant.textContent || '').trim().toLowerCase();
      if (value === 'default' || value === 'default title') this.variant.textContent = '';
    }
    sync() {
      this.cleanVariant();
      const mobile = window.matchMedia('(max-width: 989px)').matches;
      if (!mobile) { delete this.bar.dataset.ldReleaseVisible; return; }
      const header = document.getElementById('header-group');
      const headerBottom = Math.max(0, header?.getBoundingClientRect?.().bottom || 0);
      const buyboxBottom = this.buybox.getBoundingClientRect().bottom;
      const passed = buyboxBottom <= headerBottom + 8;
      this.bar.dataset.ldReleaseVisible = passed ? 'true' : 'false';
    }
    destroy() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.abort.abort();
      this.observer?.disconnect();
      if (this.bar) delete this.bar.dataset.ldReleaseVisible;
    }
  }

  const scanCollections = (scope = document) => {
    const roots = [];
    if (scope.matches?.(HERO)) roots.push(scope);
    scope.querySelectorAll?.(HERO).forEach((root) => roots.push(root));
    roots.forEach((root) => {
      if (instances.has(root)) return;
      const instance = new CollectionVideoControl(root);
      if (instance.connect()) instances.set(root, instance);
    });
  };

  const unloadCollections = (scope) => {
    const roots = [];
    if (scope.matches?.(HERO)) roots.push(scope);
    scope.querySelectorAll?.(HERO).forEach((root) => roots.push(root));
    roots.forEach((root) => instances.get(root)?.destroy());
  };

  const mountPdp = () => {
    if (document.body?.dataset.r7Route !== 'product') return;
    pdpGuard?.destroy?.();
    const next = new PdpPresentationGuard();
    pdpGuard = next.connect() ? next : null;
  };

  const boot = () => {
    installReleaseStyle();
    scanCollections();
    mountPdp();
    document.documentElement.dataset.ldSurgicalClose = OWNER;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => {
    installReleaseStyle();
    scanCollections(event.target);
    if (document.body?.dataset.r7Route === 'product') window.setTimeout(mountPdp, 0);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    unloadCollections(event.target);
    if (pdpGuard?.buybox && (event.target === pdpGuard.buybox || event.target?.contains?.(pdpGuard.buybox) || pdpGuard.buybox.contains?.(event.target))) {
      pdpGuard.destroy();
      pdpGuard = null;
    }
  });
  window.addEventListener('pagehide', () => pdpGuard?.destroy?.(), { once: true });
})();
